import { useMemo } from 'react';
// import useResponsiveQuery from 'hooks/useResponsiveQuery';
// import useUAParser from 'hooks/useUAParser';

type PermanentWalletButtonHook = () => {
  canDisplayAppleButton: boolean;
  canDisplayNonAppleButton: boolean;
};

const usePermanentWalletButton: PermanentWalletButtonHook = () => {
  // const { isMobile } = useResponsiveQuery();
  // const {
  // device: { model },
  // os: { name: os },
  // } = useUAParser();

  const canDisplayAppleButton = useMemo(() => {
    // NOTE: We may adjust this later on. In testing, we are seeing this
    // display on ipads on occasion
    // return !isMobile || (os === 'iOS' && model !== 'iPad');
    return true;
  }, []);

  const canDisplayNonAppleButton = useMemo(() => {
    // return !isMobile || os === 'Android';
    return true;
  }, []);

  return {
    canDisplayAppleButton,
    canDisplayNonAppleButton,
  };
};

export default usePermanentWalletButton;
